<template>
  <FlotoContentLoader :loading="loading">
    <div
      v-if="qrcodeChunk.length"
      id="printableArea"
      class="flex flex-1 flex-col"
    >
      <div
        v-for="(qrcodes, index) in qrcodeChunk"
        :key="index"
        class="flex items-start"
        :style="{ marginBottom: `${qrTemplate.gapBetweenLabels}mm` }"
      >
        <div
          v-for="(qrcode, i) in qrcodes"
          :key="i"
          class="cursor-pointer"
          :style="{ marginRight: `${qrTemplate.gapBetweenLabels}mm` }"
        >
          <QRCodeLabelPrint
            :key="i"
            :qr-attributes="qrcode"
            :width="qrTemplate.labelWidth"
            :height="qrTemplate.labelHeight"
            @qrcode-image-loaded="handleQrcodeImageLoaded"
          />
        </div>
      </div>
    </div>
  </FlotoContentLoader>
</template>

<script>
import { printElement } from '@utils/print'
// import { generateQrCodeForAssetUsingQrData } from '@utils/qrcode'
import QRCodeLabelPrint from '@components/qr-code-label-print.vue'
import { generateQrCodeApi } from '@src/modules/asset/asset-api'
import Chunk from 'lodash/chunk'
export default {
  name: 'PrintQrcode',
  components: { QRCodeLabelPrint },
  data() {
    return {
      loading: true,
      qrcodeDetails: [],
      qrcodeChunk: [],
      qrTemplate: {},
      loadedImages: 0,
      totalImages: 0,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const urlParams = new URLSearchParams(window.location.search)
      const assetIds = urlParams.get('assetIds')
      const moduleName = urlParams.get('moduleName')
      const templateId = urlParams.get('templateId')
      const ids = JSON.parse(assetIds)
      generateQrCodeApi(moduleName, ids, templateId).then(
        ({ qrTemplate, qrMap, qrAttributes }) => {
          this.qrTemplate = qrTemplate
          this.qrcodeChunk = Chunk(
            qrAttributes,
            qrTemplate.noOfLabelsPerRow || 2
          )
          this.totalImages = qrAttributes.length
          this.loading = false
        }
      )
    },
    handleQrcodeImageLoaded() {
      this.loadedImages++
      if (this.loadedImages === this.totalImages) {
        setTimeout(() => {
          printElement(document.getElementById('printableArea'), false, window)
        }, 500)
      }
    },
  },
}
</script>
